module.exports = __webpack_public_path__ + "static/media/test_100_100.bd3cd789.png";